export const getElement = (element?: string | HTMLElement | null): HTMLElement | null | undefined => {
  if (element !== '' && typeof element === 'string') {
    return document.querySelector(element) as HTMLElement;
  }

  return element === '' ? undefined : element;
};

const EXCEEDED_EDGE_TOLERANCE = 5;
const exceededEdges = (edgeTolerance: number, element?: string | HTMLElement | null) => {
  const targetRect = getElement(element)?.getBoundingClientRect();

  if (!targetRect) {
    return;
  }

  return {
    top: targetRect.top + edgeTolerance < 0,
    right: targetRect.right - edgeTolerance > (window.innerWidth || document.documentElement.clientWidth),
    bottom: targetRect.bottom - edgeTolerance > (window.innerHeight || document.documentElement.clientHeight),
    left: targetRect.left + edgeTolerance < 0
  };
};

export const isInViewport = (element?: string | HTMLElement, edgeTolerance = EXCEEDED_EDGE_TOLERANCE) => {
  const edges = exceededEdges(edgeTolerance, element);

  if (!edges) return;

  const { top, left, right, bottom } = edges;

  return !top && !left && !right && !bottom;
};

const SCROLL_OFFSET = 320;

export const scrollToElementNotInViewport = (element?: string | HTMLElement, scrollToTop?: boolean, offset: number = SCROLL_OFFSET) => {
  const activeElement = getElement(element);

  if (!activeElement) {
    return;
  }

  if (scrollToTop) {
    window.scrollTo({
      top: 0
    });
  } else {
    window.scrollTo({
      top: window.scrollY + activeElement.getBoundingClientRect().top - offset
    });
  }
};

// Note: this is useful when customizing Modal, e.g. Tour
// by default react-modal adds `overflow: hidden` in `body`
export const removeBodyOverflow = () => getElement('body')?.style.removeProperty('overflow');

export const toggleClassnameOnElement = (element?: string | HTMLElement, classname?: string, force?: boolean) =>
  classname && getElement(element)?.classList?.toggle(classname, force);
